import { createSlice } from '@reduxjs/toolkit';

export const initialFeatureVisibilityState = {
  flags: {
    onlineLessons: true,
    myAssessment: true,
    certificates: true,
    showCoachCalls: true,
    showLiveClass: false,
    showScore: true,
    showSettingsHistory: false,
    settings: true,
  },
  initialized: false,
  hasLoaded: false,
  status: 'idle',
  error: null,
};

function toBoolean(value, fallback = false) {
  if (value === undefined || value === null || value === '') return fallback;
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return value === 1;
  const normalized = String(value).trim().toLowerCase();
  if (['1', 'true', 'y', 'yes', 'enabled'].includes(normalized)) return true;
  if (['0', 'false', 'n', 'no', 'disabled'].includes(normalized)) return false;
  return fallback;
}

export function normalizeFeatureVisibility(data = {}) {
  return {
    onlineLessons: toBoolean(data.online_lessons, initialFeatureVisibilityState.flags.onlineLessons),
    myAssessment: toBoolean(data.my_assessment, initialFeatureVisibilityState.flags.myAssessment),
    certificates: toBoolean(data.certificates, initialFeatureVisibilityState.flags.certificates),
    showCoachCalls: toBoolean(data.show_coachcalls, initialFeatureVisibilityState.flags.showCoachCalls),
    showLiveClass: toBoolean(data.show_liveclass, initialFeatureVisibilityState.flags.showLiveClass),
    showScore: toBoolean(
      data.showScore ?? data.show_score,
      initialFeatureVisibilityState.flags.showScore,
    ),
    showSettingsHistory: toBoolean(
      data.show_settings_history,
      initialFeatureVisibilityState.flags.showSettingsHistory,
    ),
    settings: toBoolean(data.settings, initialFeatureVisibilityState.flags.settings),
  };
}

const slice = createSlice({
  name: 'featureVisibility',
  initialState: initialFeatureVisibilityState,
  reducers: {
    featureVisibilityRequested(state) {
      state.status = 'loading';
      state.error = null;
    },
    featureVisibilityLoaded(state, action) {
      state.status = 'succeeded';
      state.initialized = true;
      state.hasLoaded = true;
      state.flags = normalizeFeatureVisibility(action.payload);
      state.error = null;
    },
    featureVisibilityFailed(state, action) {
      state.status = 'failed';
      state.initialized = true;
      state.error = action.payload ?? 'Failed to load feature visibility';
    },
  },
});

export const {
  featureVisibilityRequested,
  featureVisibilityLoaded,
  featureVisibilityFailed,
} = slice.actions;

export const featureVisibilityReducer = slice.reducer;
